import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'formatMoment',
})
export class FormatMoment implements PipeTransform {
  transform(
    value: moment.Moment,
    or: string = '',
    format = 'dd DD/MM'
  ): string {
    return value == null ? or : value.locale('nl').format(format);
  }
}
